export { default as CardLocationRow } from './CardLocationRow';
